import { ThunkAction } from 'redux-thunk';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import { CompanyService } from '$/services';

import {
  ADD_CLIENT_COMPANY_TASK,
  ADD_CLIENT_COMPANY_TASK_SUCCESS,
  ADD_CLIENT_COMPANY_TASK_FAILURE,
  COMPANY_LOADING,
  COMPANY_ERROR,
  SET_CURRENT_COMPANY,
  REMOVE_COMPANY,
  CREATE_COMPANY,
  COMPANIES_LOADING,
  COMPANIES_SUCCESS,
  COMPANIES_FAILURE,
  COMPANIES_CLEAR,
  ADD_CLIENT_COMPANY,
  ADD_CLIENT_COMPANY_SUCCESS,
  ADD_CLIENT_COMPANY_FAILURE,
  DELETE_CLIENT_COMPANY,
  DELETE_CLIENT_COMPANY_SUCCESS,
  DELETE_CLIENT_COMPANY_FAILURE,
  GENERATE_PRIMER,
  GENERATE_PRIMER_SUCCESS,
  GENERATE_PRIMER_FAILURE,
  GENERATE_TEARSHEET,
  GENERATE_TEARSHEET_SUCCESS,
  GENERATE_TEARSHEET_FAILURE,
  ADD_PUBLIC_COMPANY_TASK,
  ADD_PUBLIC_COMPANY_TASK_SUCCESS,
  ADD_PUBLIC_COMPANY_TASK_FAILURE,
  DOCUMENT_ANNOUNCEMENT_LOADING,
  DOCUMENT_ANNOUNCEMENT_SUCCESS,
  DOCUMENT_ANNOUNCEMENT_FAILURE,
  MOST_RECENT_COMPANY_TASK_LOADING,
  MOST_RECENT_COMPANY_TASK_SUCCESS,
  MOST_RECENT_COMPANY_TASK_FAILURE,
  IMPORT_COMPANIES,
  IMPORT_COMPANIES_SUCCESS,
  IMPORT_COMPANIES_FAILURE,
} from './types';
import { createDraft, setDraftCompany, setDraftInProgress } from '$/store/draft/actions';
import { toastError, toastSuccess } from '$/store/toast/actions';
import { PlannerNewsService } from '$/services';

const addClientCompanyTaskAction = () => {
  return {
    type: ADD_CLIENT_COMPANY_TASK,
  };
};
const addClientCompanyTaskSuccessAction = () => {
  return {
    type: ADD_CLIENT_COMPANY_TASK_SUCCESS,
  };
};
const addClientCompanyTaskFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ADD_CLIENT_COMPANY_TASK_FAILURE,
    payload: error,
  };
};

const addPublicCompanyTaskAction = () => {
  return {
    type: ADD_PUBLIC_COMPANY_TASK,
  };
};
const addPublicCompanyTaskSuccessAction = () => {
  return {
    type: ADD_PUBLIC_COMPANY_TASK_SUCCESS,
  };
};
const addPublicCompanyTaskFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ADD_PUBLIC_COMPANY_TASK_FAILURE,
    payload: error,
  };
};

const loadCompaniesAction = () => {
  return {
    type: COMPANIES_LOADING,
  };
};

const companiesSuccessAction = (companies: Bixby.Models.AdminCompanySlim[]) => {
  return {
    type: COMPANIES_SUCCESS,
    payload: companies,
  };
};

const companiesFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: COMPANIES_FAILURE,
    payload: error,
    error: true,
  };
};

export const companiesClearAction = () => {
  return {
    type: COMPANIES_CLEAR,
  };
};

const loadCompanyAction = () => {
  return {
    type: COMPANY_LOADING,
  };
};

const errorCompanyAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: COMPANY_ERROR,
    payload: error,
    error: true,
  };
};

const createCompanyAction = (company: Bixby.Models.AdminCompany) => {
  return {
    type: CREATE_COMPANY,
    payload: company,
  };
};

export const setCompanyAction = (company?: Bixby.Models.AdminCompany) => {
  return {
    type: SET_CURRENT_COMPANY,
    payload: company,
  };
};

const removeCompanyAction = () => {
  return {
    type: REMOVE_COMPANY,
  };
};

const addClientCompanyAction = () => {
  return {
    type: ADD_CLIENT_COMPANY,
  };
};
const addClientCompanySuccessAction = () => {
  return {
    type: ADD_CLIENT_COMPANY_SUCCESS,
  };
};
const addClientCompanyFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ADD_CLIENT_COMPANY_FAILURE,
    payload: error,
    addError: true,
  };
};

const deleteClientCompanyAction = () => {
  return {
    type: DELETE_CLIENT_COMPANY,
  };
};
const deleteClientCompanySuccessAction = () => {
  return {
    type: DELETE_CLIENT_COMPANY_SUCCESS,
  };
};
const deleteClientCompanyFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: DELETE_CLIENT_COMPANY_FAILURE,
    payload: error,
    deleteError: true,
  };
};

const generatePrimerAction = () => {
  return {
    type: GENERATE_PRIMER,
  };
};
const generatePrimerSuccessAction = () => {
  return {
    type: GENERATE_PRIMER_SUCCESS,
  };
};
const generatePrimerFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: GENERATE_PRIMER_FAILURE,
    payload: error,
  };
};

const generateTearSheetAction = () => {
  return {
    type: GENERATE_TEARSHEET,
  };
};
const generateTearSheetSuccessAction = () => {
  return {
    type: GENERATE_TEARSHEET_SUCCESS,
  };
};
const generateTearSheetFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: GENERATE_TEARSHEET_FAILURE,
    payload: error,
  };
};

export const updateDocumentAnnouncementInProgressAction = () => {
  return {
    type: DOCUMENT_ANNOUNCEMENT_LOADING,
  };
};

export const updateDocumentAnnouncementSuccessAction = (announcement: string) => {
  return {
    type: DOCUMENT_ANNOUNCEMENT_SUCCESS,
    payload: announcement
  };
};

export const updateDocumentAnnouncementFailureAction = (payload: Bixby.Models.BixbyError) => {
  return {
    type: DOCUMENT_ANNOUNCEMENT_FAILURE,
    payload,
  };
};

const loadMostRecentCompanyTaskAction = () => {
  return {
    type: MOST_RECENT_COMPANY_TASK_LOADING,
  };
};
const setMostRecentCompanyTaskSuccessAction = (task: Bixby.Models.ClientCompanyTask | null) => {
  return {
    type: MOST_RECENT_COMPANY_TASK_SUCCESS,
    payload: task,
  };
};
const setMostRecentCompanyTaskFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: MOST_RECENT_COMPANY_TASK_FAILURE,
    payload: error,
    error: true,
  };
};

// thunk actions
export const addClientCompanyTask =
  (model: Bixby.Models.CreateClientCompanyTask): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(addClientCompanyTaskAction());
      try {
        await PlannerNewsService.addClientCompanyTaskAsync(model);
        await dispatch(getMostRecentCompanyTask(model.companyId || ''));
        await dispatch(addClientCompanyTaskSuccessAction());
        await dispatch(toastSuccess(`Task created`));
      } catch (error: any) {
        await dispatch(addClientCompanyTaskFailureAction(error));
        await dispatch(toastError(`Failed to create task`));
      }
    };

// thunk actions
export const addPublicCompanyTask =
  (model: Bixby.Models.CreatePublicCompanyTask): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(addPublicCompanyTaskAction());
      try {
        await PlannerNewsService.addPublicCompanyTaskAsync(model);
        await dispatch(addPublicCompanyTaskSuccessAction());
        await dispatch(toastSuccess(`Task created`));
      } catch (error: any) {
        await dispatch(addPublicCompanyTaskFailureAction(error));
        await dispatch(toastError(`Failed to create task`));
      }
    };

export const getCompanies =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(loadCompaniesAction());
    try {
      const companies = await CompanyService.getAll();
      dispatch(companiesSuccessAction(companies));
      dispatch(setCompanyAction(undefined));
      dispatch(setDraftInProgress(false));
      dispatch(setDraftCompany(undefined));
    } catch (error: any) {
      dispatch(companiesFailureAction(error));
    }
  };

export const setCurrentCompany =
  (companyId: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(loadCompanyAction());
      try {
        const company = await CompanyService.getAdminCompany(companyId);
        dispatch(setCompanyAction(company));
      } catch (error: any) {
        dispatch(errorCompanyAction(error));
      }
    };

export const createCompany =
  (
    newCompany: Bixby.Models.CreateCompanyRequest
  ): ThunkAction<Promise<boolean>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(loadCompanyAction());
      try {
        const company = await CompanyService.createCompany(newCompany);
        await dispatch(createCompanyAction(company));
        await dispatch(createDraft(company.id));
        await dispatch(companiesClearAction());
        dispatch(toastSuccess(`${company.name} created`));
        return true;
      } catch (error: any) {
        const status = Bixby.API.getStatus(error);
        if (status === 409) {
          const detail: string =
            error?.response?.data ??
            `A company with BixbyId '${newCompany.bixbyId}' already exists.`;
          dispatch(toastError(detail));
        } else {
          dispatch(toastError(`Failed to create company`));
        }
        dispatch(errorCompanyAction(error));
        return false;
      }
    };

export const removeCompany =
  (companySlim: Bixby.Models.AdminCompanySlim): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(loadCompanyAction());
      try {
        await CompanyService.removeCompany(companySlim.id);
        dispatch(removeCompanyAction());
        await dispatch(companiesClearAction());
        await dispatch(toastSuccess(`${companySlim.name} deleted`));
      } catch (error: any) {
        await dispatch(toastError(`Could not delete ${companySlim.name}`));
        dispatch(errorCompanyAction(error));
      }
    };

export const addClientCompany =
  (
    clientId: string,
    companyId: string,
    onAddSuccess: () => void
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(addClientCompanyAction());
      try {
        await CompanyService.addClientCompany(clientId, companyId);
        dispatch(addClientCompanySuccessAction());
        onAddSuccess();
        await dispatch(toastSuccess(`Client Notified`));
      } catch (error: any) {
        dispatch(addClientCompanyFailureAction(error));
        await dispatch(toastError(`Company could not be added`));
      }
    };

export const deleteClientCompany =
  (
    clientId: string,
    companyId: string,
    onDeleteSuccess: () => void
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(deleteClientCompanyAction());
      try {
        await CompanyService.deleteClientCompany(clientId, companyId);
        dispatch(deleteClientCompanySuccessAction());
        onDeleteSuccess();
      } catch (error: any) {
        dispatch(deleteClientCompanyFailureAction(error));
        await dispatch(toastError(`Company could not be deleted`));
      }
    };

export const generatePrimer =
  (companyId: string, clientId: string | null): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      try {
        dispatch(generatePrimerAction());
        await CompanyService.generatePrimer(companyId, clientId);
        dispatch(generatePrimerSuccessAction());
        await dispatch(setCurrentCompany(companyId));
        await dispatch(toastSuccess(`Generating Primer...`));
      } catch (error: any) {
        dispatch(generatePrimerFailureAction(error));
        await dispatch(toastError(`Error generating Primer`));
      }
    };

export const generateTearSheet =
  (companyId: string, clientId: string | null): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      try {
        dispatch(generateTearSheetAction());
        await CompanyService.generateTearSheet(companyId, clientId);
        dispatch(generateTearSheetSuccessAction());
        await dispatch(setCurrentCompany(companyId));
        await dispatch(toastSuccess(`Generating Tearsheet...`));
      } catch (error: any) {
        dispatch(generateTearSheetFailureAction(error));
        await dispatch(toastError(`Error generating Tearsheet`));
      }
    };

export const updateDocumentAnnouncement =
  (companyId: string, notes: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(updateDocumentAnnouncementInProgressAction());
      try {
        await CompanyService.updateDocumentAnnouncement(companyId, notes);
        await dispatch(updateDocumentAnnouncementSuccessAction(notes));
        await dispatch(toastSuccess('Announcement saved'));
      } catch (error: any) {
        await dispatch(toastError('Failed to save announcement'));
        dispatch(updateDocumentAnnouncementFailureAction(error));
      }
    };

export const getMostRecentCompanyTask =
  (companyId: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(loadMostRecentCompanyTaskAction());
    try {
      const task = await CompanyService.getMostRecentCompanyTask(companyId);
      dispatch(setMostRecentCompanyTaskSuccessAction(task));
    } catch (error: any) {
      dispatch(setMostRecentCompanyTaskFailureAction(error));
    }
  };

const importCompaniesAction = () => ({ type: IMPORT_COMPANIES });
const importCompaniesSuccessAction = () => ({ type: IMPORT_COMPANIES_SUCCESS });
const importCompaniesFailureAction = (error: Bixby.Models.BixbyError) => ({
  type: IMPORT_COMPANIES_FAILURE,
  payload: error,
});

export const importCompanies =
  (companiesFile: File): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
    async dispatch => {
      dispatch(importCompaniesAction());
      try {
        await CompanyService.importCompanies(companiesFile);
        dispatch(importCompaniesSuccessAction());
        dispatch(toastSuccess('Company import submitted successfully'));
      } catch (error: any) {
        dispatch(importCompaniesFailureAction(error));
        throw error;
      }
    };
